import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgClass, NgFor } from '@angular/common';
import { RevealOnScrollDirective } from '../../reveal-on-scroll.directive';
import { ServicesSectionService } from './services-section.service';

@Component({
  selector: 'app-services-section',
  standalone: true,
  imports: [NgClass, NgFor, RevealOnScrollDirective],
  templateUrl: './services-section.component.html',
  styleUrl: './services-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ServicesSectionComponent {
  get content() {
    return this.servicesService.content;
  }

  constructor(private readonly servicesService: ServicesSectionService) {}
}
